import { ActionTypes } from '../constants/ActionTypes';

export function login(account) {
    return {
        type: ActionTypes.LOGIN,
        account
    };
};

export function getLogin(user, msg) {
    return {
        type: ActionTypes.GET_LOGIN,
        msg: msg,
        user
    }
}

export function checkLogin(token,router) {
    if (token === "") {
        router.push("/login");
    }
}

export function getToken(token) {
    return {
        type: ActionTypes.GET_TOKEN,
        token
    }
}
export function removeToken() {
    return {
        type: ActionTypes.REMOVE_TOKEN,
    }
}



// WEBPACK FOOTER //
// ./src/actions/auth.js